"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@requestnetwork/types");
const native_token_1 = require("../native-token");
const CURRENT_VERSION = '0.2.0';
/**
 * Implementation of the payment network to pay in Near based on input data.
 */
class NearNativePaymentNetwork extends native_token_1.default {
    constructor(currencyManager, supportedNetworks = [
        'aurora',
        // FIXME: enable near network support
        // 'near'
    ], currentVersion = CURRENT_VERSION) {
        super(currencyManager, types_1.ExtensionTypes.PAYMENT_NETWORK_ID.NATIVE_TOKEN, currentVersion, supportedNetworks);
    }
    /**
     * Check if a near address is valid
     *
     * @param {string} address address to check
     * @returns {boolean} true if address is valid
     */
    isValidAddress(address) {
        return this.isValidAddressForSymbolAndNetwork(address, 'NEAR', 'aurora');
    }
}
exports.default = NearNativePaymentNetwork;
